import {
  fetchWeatherAlertsSettings,
  saveWeatherAlertsSettings,
} from './weather.actions';
import {
  trackWeatherRequests,
  updateweatherAlerts,
} from './weather.repository';
import { getErrorContext } from '../../../utils/get-error-context';
import { reportToTrackjs } from '../../../utils/report-to-trackjs';
import {
  createEffect,
  ofType,
  registerEffects,
  removeEffects,
  tapResult,
} from '@ngneat/effects';
import { switchMap } from 'rxjs';
import {
  NormalizedResponse,
  TripManagementSettingsApi,
} from '@tmx/data-access';

const TRACKJS_SOURCE = 'weather effects';

const fetchWeatherAlertsSettings$ = createEffect((actions) =>
  actions.pipe(
    ofType(fetchWeatherAlertsSettings),
    switchMap(() =>
      TripManagementSettingsApi.getConfigurationSectionName(
        'weatherAlerts'
      ).pipe(
        trackWeatherRequests(['fetch-weather-alerts']),
        tapResult(
          ({ weatherAlerts }) => {
            if (typeof weatherAlerts !== 'undefined') {
              updateweatherAlerts(weatherAlerts);
            }
          },
          (error: NormalizedResponse) => {
            reportToTrackjs(
              TRACKJS_SOURCE,
              'Error loading Weather Alerts settings',
              getErrorContext(error)
            );
          }
        )
      )
    )
  )
);

const saveWeatherAlertsSettings$ = createEffect((actions) =>
  actions.pipe(
    ofType(saveWeatherAlertsSettings),
    switchMap(({ weatherAlerts }) =>
      TripManagementSettingsApi.patchConfigurationWeatherAlerts(
        weatherAlerts
      ).pipe(
        trackWeatherRequests(['save-weather-alerts']),
        tapResult(() => {
          updateweatherAlerts(weatherAlerts);
        })
      )
    )
  )
);

const effects = [fetchWeatherAlertsSettings$, saveWeatherAlertsSettings$];

export function registerWeatherEffects() {
  registerEffects(effects);
}

export function deregisterWeatherEffects() {
  removeEffects(effects);
}
